// src/components/molecules/IconButtonWithTooltip/IconButtonWithTooltip.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';

/**
 * IconButtonWithTooltip - Componente molecular que combina um IconButton com um Tooltip
 * 
 * Este componente segue o princípio do Atomic Design, funcionando como uma "molécula"
 * que combina dois átomos: IconButton e Tooltip.
 * 
 * CLASSIFICAÇÃO: MOLÉCULA - Combina dois átomos (IconButton + Tooltip)
 */
const IconButtonWithTooltip = ({
  title,
  icon,
  onClick,
  size = 'small',
  color = 'inherit',
  sx = {},
  disabled = false,
  placement = 'top',
  className = '',
  ...rest
}) => {
  // Utilizamos um span como wrapper para o Tooltip funcionar corretamente
  // quando o botão estiver desabilitado
  return (
    <Tooltip 
      title={title} 
      arrow 
      placement={placement} 
      disableInteractive={false}
      disableFocusListener={disabled}
      disableHoverListener={disabled}
      disableTouchListener={disabled}
    >
      <span>
        <IconButton 
          size={size}
          color={color}
          onClick={onClick}
          sx={sx}
          disabled={disabled}
          className={className}
          {...rest}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
};

IconButtonWithTooltip.propTypes = {
  /** Texto a ser exibido no tooltip */
  title: PropTypes.string.isRequired,
  /** Ícone a ser renderizado dentro do botão */
  icon: PropTypes.node.isRequired,
  /** Função a ser executada ao clicar no botão */
  onClick: PropTypes.func,
  /** Tamanho do botão ('small', 'medium', 'large') */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /** Cor do botão */
  color: PropTypes.string,
  /** Estilos customizados usando o sistema de estilos do MUI */
  sx: PropTypes.object,
  /** Se o botão está desabilitado */
  disabled: PropTypes.bool,
  /** Posição do tooltip em relação ao botão */
  placement: PropTypes.oneOf([
    'top', 'right', 'bottom', 'left', 
    'top-start', 'top-end', 
    'bottom-start', 'bottom-end', 
    'left-start', 'left-end', 
    'right-start', 'right-end'
  ]),
  /** Classes CSS adicionais */
  className: PropTypes.string,
};

export default IconButtonWithTooltip;











